import React from 'react';
import PropTypes from 'prop-types'
import AppStore from '../../stores/AppStore';
import AppActions from '../../actions/AppActions';
import TemplateData, { localsMessages, guestLocalsMessages } from '../../utility/getTemplateData';
import GlobalBanner from '../../components/globalBanner';
import SubHeader from '../../components/subHeader';
import SingleAmount from '../../components/amount/SingleAmount';
import CancelAndReturn from '../../components/cancelAndReturn';
import _get from 'lodash/get';
import _includes from 'lodash/includes';
import _isEmpty from 'lodash/isEmpty';
import { DonateGiftAid } from 'guest-payment';
import * as FPT from '../../utility/fpt'
import CurrencyConversionModal from '../../components/currencyConversion/CurrencyConversionModal';
import { normalizeNumber } from '../../utility/formator';
import fonts from '../../styles/fonts';
import { css } from 'aphrodite';

let giftAidText = localsMessages('common/giftAidIt');
const donateGiftPercentage = AppStore.getGiftAidItExtraAmount();
let giftAidTextObj = giftAidText && giftAidText.giftAidIt || {};
let { extraCost } = giftAidTextObj;
const guestMessages = guestLocalsMessages('guest/guestForm');
const messages = localsMessages('guest/crossBorder');

const STYLES = {
	donateBtnContainer: {
		maxWidth: '360px',
		margin: '20px auto 0px',
		fontFamily: fonts.ppSansBigMedium
	},
	donateBtn: {
		marginBottom: 0,
		fontFamily: fonts.ppSansBigMedium
	},
	centralFormWrapper: {
		maxWidth: '500px',
		width: '100%',
		margin: '0 auto',
		padding: '0 18px',
	},
	donationSeparator: {
		marginBottom: '25px'
	},
	formTopLabelBold: {
		fontWeight: 'bold',
		marginTop: 31,
		fontSize: 15,
		fontFamily: fonts.ppSansSmallMedium
	},
	formLabelLeft: {
		width: '70%',
		fontSize: 15,
		textAlign: 'left',
		fontFamily: fonts.ppSansBigRegular
	},
	formLabelRight: {
		width: '30%',
		fontSize: 15,
		textAlign: 'right',
		fontFamily: fonts.ppSansBigRegular
	},
	formLabelLeftConv: {
		width: '70%',
		fontSize: 12,
		textAlign: 'left',
		fontFamily: fonts.ppSansBigRegular
	},
	formLabelRightConv: {
		width: '30%',
		fontSize: 12,
		textAlign: 'right',
		fontFamily: fonts.ppSansBigRegular
	},
	formLabelCenter: {
		width: '100%',
		marginTop: '10px',
		textAlign: 'center'
	},
	conversionBlock: {
		maxWidth: '500px',
		width: '100%',
		margin: '20px auto 10px',
		padding: '23px 0 20px 0',
		backgroundColor: '#F1F8FC',
		borderRadius: '5px',
		fontFamily: fonts.ppSansSmallRegular
	},
	formLabelRateLeft: {
		width: '70%',
		fontSize: 12,
		textAlign: 'left',
		fontFamily: fonts.ppSansSmallRegular
	},
	formLabelRateRight: {
		width: '30%',
		fontSize: 12,
		textAlign: 'right',
		fontFamily: fonts.ppSansSmallRegular
	},
	conversionRate: {
		maxWidth: '500px',
		width: '100%',
		padding: '0 18px',
		margin: '12px auto 0'
	},
	policyMsg: {
		fontSize: '0.85em',
		textAlign: 'center',
		color: '#848B8E'
	},
	labelFont: {
		fontSize: 12,
		fontFamily: fonts.ppSansSmallRegular
	},
	alignmentPadding: {
		padding: '0 18px'
	},
	link: {
		color: '#0270ba'
	}
};

const DYNAMIC_CURRENCY_CONVERSION_TAG = 'DYNAMIC_CURRENCY_CONVERSION';
export const CURRENCY_CONVERSION_OPTIONS = {
	PAYPAL: 'PAYPAL',
	ISSUER: 'ISSUER'
};

class CrossBorder extends React.Component {
    static contextTypes = {
		router: PropTypes.object.isRequired
	};

	constructor(props) {
		super(props);

		let isRecurring = !!AppStore.getDonationRecurring();
		const stateConversionWithPayPal = this.getStateForConversionWithPayPal();

		this.state = {
			subHeaderLabel: TemplateData.donationName,
			donationId: TemplateData.donationId,
			orgName: TemplateData.charityName,
			amountDecimalPoint: TemplateData.donationDecimalPoint || '.',
			decimalPoint: TemplateData.donationDecimalPoint || '.',
			isRecurring,
			...stateConversionWithPayPal
		};
	};

	getStateForConversionWithPayPal() {
		let fundingOptions = AppStore.getFundingOptions();
		let [fundingSources] = fundingOptions ? fundingOptions.sources : [];
		let paymentNetwork = fundingSources.payment_card.network.toLowerCase();
		paymentNetwork = paymentNetwork.charAt(0).toUpperCase() + paymentNetwork.slice(1);
		let paymentDigits = fundingSources.payment_card.last_4;
		let exchangeRate = parseFloat(
			fundingOptions.currency_conversion.exchange_rate
		).toFixed(2);
		let fundsIn = fundingOptions.currency_conversion.funds_in;
		let fundsOut = fundingOptions.currency_conversion.funds_out;
		let isRecurring = !!AppStore.getDonationRecurring();

		return {
			exchangeRate,
			paymentCard: `${paymentNetwork} x-${paymentDigits}`,
			inAmount: fundsIn.value,
			inCurrency: fundsIn.currency,
			inSymbol: fundsIn.symbol,
			outAmount: fundsOut.value,
			outCurrency: fundsOut.currency,
			outSymbol: fundsOut.symbol,
			currencyConversionOption: CURRENCY_CONVERSION_OPTIONS.PAYPAL
		}
	};

	getStateForConversionWithIssuer() {
		let amount = AppStore.getDonationAmount();
		let symbol = AppStore.getDonationSymbol();
		let currency = AppStore.getDonationCode();

		// No currency_conversion. fundsIn and fundsOut will not be available.
		return {
			amount,
			symbol,
			currency,
			currencyConversionOption: CURRENCY_CONVERSION_OPTIONS.ISSUER
		};
	};

	updateFundingOptionsState() {
		let fundingOptions = AppStore.getFundingOptions();
		if (!fundingOptions.currency_conversion) {
			this.setState(this.getStateForConversionWithIssuer());
		} else {
			this.setState(this.getStateForConversionWithPayPal());
		}
	};

    getLocalizedAmount = (amount) => {
		amount = (parseFloat(amount)).toFixed(2);
		return `${amount}`.replace(/[.|,]/i, this.state.amountDecimalPoint);
	};

	handleCurrencyConversionClick = () => {
		FPT.trackLinkClick('showCurrencyConversionModal');
		this.showCurrencyConversionModal();
	};

	showCurrencyConversionModal() {
		$("#currencyConversion").modal('show');
	};

	hideCurrencyConversionModal() {
		$('#currencyConversion').modal('hide');
	};

    handleDonateClick = () => {
		$('.spinneroverlay').show();

		$.post('/donate/guest/fullfilment', {
			note: AppStore.getDonationNote(),
			fundingOptionId: AppStore.getFundingOptions().id,
			email: AppStore.getEmail(),
			billingAddress: AppStore.getBillingAddress(),
			giftAidItFlag: AppStore.getGiftaidItFlagStatus() || false
		}, (result) => {
			if (result.status === 'redirect') {
				window.location.href = result.url;
			} else if (result.data && result.data.confirmationData) {
				let confirmationData = result.data.confirmationData || {};

				AppActions.updateConfirmation({confirmation: confirmationData});

				if (confirmationData.isOfacPending) {
					this.context.router.push('/donate/guest/pending');
				} else {
					this.context.router.push('/donate/guest/confirmation');
				}
			} else {
				this.context.router.push('/donate/error/payment');
			}
		}).fail(() => {
			this.context.router.push('/donate/error/payment');
		}).always(() => {
			$('.spinneroverlay').hide();
		});
	};

	handleGiftAidOption = (giftAidState) =>  {
		AppActions.updateGiftaidItFlag({ giftAidItFlag: giftAidState });
	};

	updateGiftAidComponent = (state) => {
		let extraCostText = extraCost;
		extraCostText = extraCostText && extraCostText.replace(/{currency}/g, state.outSymbol);
		extraCostText = extraCostText && extraCostText.replace("{amount}", state.outAmount);
		extraCostText = extraCostText && extraCostText.replace("{extraAmount}", (donateGiftPercentage * state.outAmount).toFixed(2));

		let modalp1 = giftAidTextObj && giftAidTextObj.modalp1 || '',
		modalp2 = giftAidTextObj && giftAidTextObj.modalp2 || '';

		modalp1 = modalp1 && modalp1.replace("{orgName}", state.subHeaderLabel);
		modalp2 = modalp2 && modalp2.replace("{orgName}", state.subHeaderLabel);

		giftAidTextObj.extraCost = extraCostText;
		giftAidTextObj.modalp1 = modalp1;
		giftAidTextObj.modalp2 = modalp2;
	}

	handleOptionSelection = (option) => {
		const beforeOption = this.state.currencyConversionOption;
		this.setState({
			currencyConversionOption: option
		}, () => {
			// Do Planning if the option has changed
			if (beforeOption !== option) {
				this.hideCurrencyConversionModal();
				this.showSpinnerOverlay();
				this.getFundingOptions()
					.always(() => {
						this.hideSpinnerOverlay();
					});

			} else {
				setTimeout(() => {
					this.hideCurrencyConversionModal();
				}, 300);
			}
		});
	};

	showSpinnerOverlay() {
		$('.spinneroverlay').show();
	};
	hideSpinnerOverlay() {
		$('.spinneroverlay').hide();
	};

	getFundingOptions() {
		const lastFundingSource = this.getLastFundingSource();
		const paymentCardId = _get(lastFundingSource, 'payment_card.id');
		
		const currencyConversionType = this.state.currencyConversionOption;

		return $.post('/donate/guest/fundingOptions', {
			amount: normalizeNumber(AppStore.getDonationAmount()),
			code: AppStore.getDonationCode(),
			fundingOptionId: AppStore.getFundingOptions().id,
			preferences: {
				currency_conversion: [{
					"payment_card_id": paymentCardId,
					"type": currencyConversionType,
					"validity": "TRANSACTION"
				}]
			},
			consentShareAddress: AppStore.getShareAddress()
		}, (result) => {

			let fundingOptions;
			// The funding options data format returned by the server is
			// different for ISSUER and PAYPAL. Handle it appropriately.
			
			// For conversion with 'ISSUER'
			if (currencyConversionType === CURRENCY_CONVERSION_OPTIONS.ISSUER) {
				fundingOptions = _get(result, 'data.fundingOpt[0]');
			} else {
				// For conversion with 'PAYPAL'
				fundingOptions = _get(result, 'fundingOpts[0]');
			}

			// Handle error case where fundingOptions call succeeds
			// but no data is returned
			if (_isEmpty(fundingOptions)) {
				FPT.trackError({
					message: 'FUNDING_OPTIONS_EMPTY_CROSSBORDER',
					code: currencyConversionType
				});
				this.context.router.push('/donate/error/payment');
				return;
			}

			// Updating store with funding options
			AppActions.updateFundingOptions({ fundingOptions });

			this.updateFundingOptionsState();

			console.log(result);
		}).fail(() => {
			console.log('FAILED');
			this.context.router.push('/donate/error/payment');
		}).always(() => {
			$('.spinneroverlay').hide();
		});
	};

	renderConversionRateInfo(exchangeRate, fundsOut) {
		const label = _get(messages, 'label', {});
		return (
			<div>
				<div style={STYLES.conversionRate}>
					<label style={STYLES.formLabelRateLeft}>
						{label.conversion} {exchangeRate}
					</label>
					<label style={STYLES.formLabelRateRight}>
						{fundsOut}
					</label>
				</div>
			</div>
		);
	};

	getLastFundingSource() {
		let fundingOptions = AppStore.getFundingOptions();
		const fundingSources = fundingOptions.sources || [];
		return fundingSources[fundingSources.length - 1];
	};

	/**
	 * Returns true if currency conversion options should be displayed
	 * @param  {Array} fundingSources Funding Sources
	 * @return {Boolean}              True if currency conversion options should be displayed
	 */
	shouldShowCurrencyConversionOptions = () => {
		const lastFundingSource = this.getLastFundingSource();
		const tags = _get(lastFundingSource, 'tags');
		return _includes(tags, DYNAMIC_CURRENCY_CONVERSION_TAG);
	};

	renderCurrencyConversionOptionsLink(label) {
		return (
			<div style={ { paddingLeft: '12px' } }>
				{
					this.state.currencyConversionOption === CURRENCY_CONVERSION_OPTIONS.PAYPAL ?
					<div>
						<label style={{...STYLES.labelFont, ...STYLES.alignmentPadding}}>
							{label.spread}
						</label>
					</div> :
					null
				}
				<div>
					<a href="#"
						className="btn btn-primary pp_cancel_btn"
						style={{ ...STYLES.labelFont, ...STYLES.alignmentPadding}}
						id="cancelReturnBtn"
						onClick={this.handleCurrencyConversionClick}
						dangerouslySetInnerHTML={{__html : label.currencyConversionOptions}}>
	                </a>
	            </div>
			</div>
		);
	};

    render() {
		const inAmount = this.getLocalizedAmount(this.state.inAmount);
		const outAmount = this.getLocalizedAmount(this.state.outAmount);
		const fundsIn = `${this.state.inSymbol}${inAmount} ${this.state.inCurrency}`;
		const fundsOut = `${this.state.outSymbol}${outAmount} ${this.state.outCurrency}`;
		const exchangeRate = `${this.getLocalizedAmount('1.00')} ${this.state.inCurrency} = ${this.getLocalizedAmount(this.state.exchangeRate)} ${this.state.outCurrency}`;
		const { label = {} } = messages || {};
		let donateNowRecurring = _get(guestMessages, 'guestLabels.donatenowrec');
		donateNowRecurring = donateNowRecurring && donateNowRecurring.replace('{amount}', fundsOut);

		const formattedDonationAmount = `${this.state.symbol ? this.state.symbol : ''}${this.state.amount} ${this.state.currency}`;

		let giftaidFlag = AppStore.getGiftaidItFlagStatus();
		this.updateGiftAidComponent(this.state);		

		return (<div className="donate_wrapper">
			<div id="crossBorderContainer" className="container">
				<GlobalBanner logourl={this.state.logourl}/>
				<SubHeader
					label={this.state.subHeaderLabel}
					donationId={this.state.donationId}
					orgName={this.state.orgName}
				/>
				{ /* <Amount
					amount={outAmount}
					symbol={this.state.outSymbol}
					decimalPoint={this.state.decimalPoint}
					code={this.state.outCurrency}/> */ }

				{TemplateData.isGiftaiditEnabled && <DonateGiftAid 												
														isAlreadyEnrolled={giftaidFlag} 
														showAddress={false}
														addressData=''
														isChecked={giftaidFlag}
														handleGiftAidOption={this.handleGiftAidOption}
														contentMsg={giftAidTextObj}/>
				}

				<div style={STYLES.centralFormWrapper}>
					<label style={STYLES.formTopLabelBold}>
						{label.donatingFrom}
					</label>
					<div
						className="donate_linner_div center-block"
						style={STYLES.donationSeparator}/>

					<label style={STYLES.formLabelLeft}>
						{this.state.paymentCard}
					</label>
					<label style={STYLES.formLabelRight}>
						{
							this.state.currencyConversionOption === CURRENCY_CONVERSION_OPTIONS.PAYPAL ?
							fundsIn :
							formattedDonationAmount
						}
					</label>
				</div>

				{
					this.state.currencyConversionOption === CURRENCY_CONVERSION_OPTIONS.PAYPAL ?
					<div style={STYLES.conversionBlock}>
						<div style={STYLES.centralFormWrapper}>
							<label style={STYLES.formLabelLeft}>
								{label.youllDonate}
							</label>
							<label style={STYLES.formLabelRight}>
								{fundsIn}
							</label>

							<label style={STYLES.formLabelLeftConv}>
								{label.convertsTo}
							</label>
							<label style={STYLES.formLabelRightConv}>
								{fundsOut}
							</label>
						</div>
					</div> :

					<div style={STYLES.conversionBlock}>
						<div style={STYLES.centralFormWrapper}>
							<label style={STYLES.formLabelLeft}>
								{label.youllDonate}
							</label>
							<label style={STYLES.formLabelRight}>
								{formattedDonationAmount}
							</label>
						</div>
					</div>


				}

				{ this.state.currencyConversionOption === CURRENCY_CONVERSION_OPTIONS.PAYPAL &&  this.renderConversionRateInfo(exchangeRate, fundsOut) }
				{ this.shouldShowCurrencyConversionOptions() && this.renderCurrencyConversionOptionsLink(label) }
				
				<div style={ { height: '40px' } } />

				<div
					style={STYLES.policyMsg}
					dangerouslySetInnerHTML={{__html: label.policies}}/>

				<div style={STYLES.donateBtnContainer} >
					<button
						id="donate-button"
						type="button"
						style={STYLES.donateBtn}
						className="vx_btn vx_btn-block"
						onClick={this.handleDonateClick}>
						{ this.state.isRecurring ? donateNowRecurring : label.donatenow}
					</button>
				</div>
				<CancelAndReturn />
				<CurrencyConversionModal
					exchangeRate={exchangeRate}
					handleOptionSelection={this.handleOptionSelection}
					hideModal={this.hideCurrencyConversionModal}
					selectedOption={this.state.currencyConversionOption}
				/>
			</div>
		</div>);
	}
}

export default CrossBorder;



// WEBPACK FOOTER //
// ./pages/guest/crossBorder.js